import React from 'react';
import { withTranslation } from '../../ChildrenContext';
import PropTypes from 'prop-types';

const ServerErrorPage = ({ t }) => {
    const staticNames = t?.errorPage?.server || {};

    return (
        <div className="notfound text-center">
            <h1>500</h1>
            <h3 className="font-bold">{staticNames.title}</h3>
            <div className="error-desc">
                {staticNames.text}
            </div>
        </div>
    );
};

ServerErrorPage.propTypes = {
    t: PropTypes.object
};

export default withTranslation(ServerErrorPage);
